import moment from 'moment-timezone';

export const EXPRESS_PHOTO: string = 'express_photo';

const defaultDateError = '-';

export const convertToShortDate = (date: string) => {
  let _date = new Date(date);
  const retDate = moment(_date)
    // IMPORTANT: here we are not using DayJS because it has compatibility issue with IE11.
    .tz('America/New_York')
    .format('MM/DD/YYYY');
  return retDate === 'Invalid date' ? defaultDateError : retDate;
};

export const convertToShortDateTime = (date: Date | string) => {

  if (!date) {
    return defaultDateError;
  }

  if (typeof(date) === 'string') {
    date=new Date(date);
  }

  const retDate = moment(date)
    // IMPORTANT: here we are not using DayJS because it has compatibility issue with IE11.
    .tz('America/New_York')
    .format('MM/DD/YYYY [at] hh:mm a');

  return retDate === 'Invalid date' ? defaultDateError : retDate;
};

export const formatCurrency = (amount: string) => `$${parseFloat(amount).toFixed(2)}`;

export const escapeString = (inputString: string) => {
  return inputString
    .replace(/\\/g, '\\')
    .replace(/\\'/g, '\\\'')
    .replace(/\\n/g, '\\n')
    .replace(/\\"/g, '\\"')
    .replace(/\\&/g, '\\&')
    .replace(/\\r/g, '\\r')
    .replace(/\\t/g, '\\t')
    .replace(/\\b/g, '\\b')
    .replace(/\\f/g, '\\f');

};

export const maskMfaTarget = (mfaTarget: string) => {
  if (mfaTarget.includes('@')) {
    const [userName, domain] = mfaTarget.split('@');
    if (!userName || !domain) return mfaTarget;

    const visiblePart = userName.slice(0, 2);
    const maskedPart = '*'.repeat(Math.max(userName.length - 2, 0));
    return `${visiblePart}${maskedPart}@${domain}`;
  } else {
    const digits = mfaTarget.replace(/\D/g, ''); //Remove non-digit characters
    if (digits.length !== 10) return mfaTarget;

    const lastFourDigits = digits.slice(-4);
    return `(***) ***-${lastFourDigits}`;
  }
};
